<template>
  <el-main class="el-main-wrapper">
    <router-view :key="$route.fullPath"></router-view>
  </el-main>
</template>
<script>
export default {
  name: 'LayoutMain'
}
</script>
<style lang="stylus">
.el-main-wrapper {
  background: #F0F2F5;
  flex: 0 0 calc(100% - 200px);
  height: calc(100vh - 60px);
  overflow: auto;
  padding: 0;
}
</style>
